import { PublicProduct } from "@/hooks/usePublicMenu";
import { TabletProductCard } from "./TabletProductCard";

interface TabletProductGridProps {
  products: PublicProduct[];
  getItemQuantity: (productId: string) => number;
  onAddProduct: (product: PublicProduct, notes?: string) => void;
  onRemoveProduct: (productId: string) => void;
}

export function TabletProductGrid({
  products,
  getItemQuantity,
  onAddProduct,
  onRemoveProduct,
}: TabletProductGridProps) {
  if (products.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <p className="text-slate-400 text-lg">
          Nenhum produto encontrado nesta categoria
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {products.map((product) => (
        <TabletProductCard
          key={product.id}
          product={product}
          quantity={getItemQuantity(product.id)}
          onAdd={(notes) => onAddProduct(product, notes)}
          onRemove={() => onRemoveProduct(product.id)}
        />
      ))}
    </div>
  );
}
